module.exports = __webpack_public_path__ + "static/img/13.da996bc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/1/zh/13.png
// module id = z8jd
// module chunks = 0